import React, { useState } from 'react';
import { useLazyQuery } from "@apollo/react-hooks";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

import './pincode-input-style.scss';

import Typography from '@src/componentsNew/Typography/Typography';
import Button from '@src/componentsNew/Buttons/Button';

import { PINCODE } from "@organisms/ProductPincodeCheck/queries";
import { pincode } from "@organisms/ProductPincodeCheck/__generated__/pincode";

const PincodeInput = ({ productType, pincode, setPincode }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [pincodeResultState, setPincodeResultState] = useState('');
  const [pincodeResultText, setPincodeResultText] = useState('');

  const [fetchPincode, { data, error, loading }] = useLazyQuery<pincode>(PINCODE, {
    onError: (error) => {
      setIsChecked(true);
      setPincodeResultState('impossible');
      setPincodeResultText('Sorry. We are unable to deliver to this pincode with prepaid currently');
    },
    onCompleted: (data) => {
      setIsChecked(true);
      const pincodeData = data.pincode;
      const isPrepaid = pincodeData.isPrepaid;
      const isShippable = pincodeData.isShippable;
      const isCod = pincodeData.isCod;

      // 배송 불가능
      if (!isPrepaid || !isShippable) {
        setPincodeResultState('impossible');
        setPincodeResultText('Sorry. We are unable to deliver to this pincode with prepaid currently');
      } else {
        // 배송가능, MGS 상품인 경우
        if (productType.isMgs) {
          setPincodeResultText('Delivery Available');
        } else {
          // MGS 상품이 아닌 경우
          const possibleArr = [];

          if (isPrepaid) {
            possibleArr.push('Prepaid');
          }

          if (!productType.isCodRestricted && isCod) {
            possibleArr.push('COD');
          }

          const resultText = possibleArr.join(', ');
          setPincodeResultText(`${resultText} Available`);
        }
        if (pincodeData.city) {
          setPincode(`${pincodeData.pincode} (${pincodeData.city})`)
        }
        setPincodeResultState('possible');
      }
    },
  });

  const handlePincodeChange = (event) => {
    const newPincode = event.target.value.replace(/\D/g, '');

    if (newPincode.length <= 6) {
      setIsChecked(false);
      setPincode(newPincode);
      setPincodeResultState('');
      setPincodeResultText('');
    }
  };

  const checkPincode = () => {
    fetchPincode({
      variables: { pincode },
    });
  };

  return (
    <div id="pincode-input-wrapper">
      <TextField
        size='small'
        className="pincode-input"
        label="Pincode"
        value={pincode}
        disabled={loading}
        onChange={handlePincodeChange}
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {
                pincode.length === 6 ?
                  <Button
                    size='small'
                    style={{ color: '#FF3399' }}
                    onClick={checkPincode}>
                    Check
                  </Button>
                  : null
              }
            </InputAdornment>
          )
        }}
      />

      {
        pincode.length && isChecked && pincodeResultText ?
          <Typography cName={`pincode-result-text ${pincodeResultState}`} variant="body3" component="p">
            {pincodeResultText}
          </Typography>
          : null
      }
    </div>
  );
};

export default PincodeInput;
